import { useBlocker } from "react-router-dom";

import type { IPromptProps } from "@contexts/router/types";

export const Prompt: React.FC<IPromptProps> = ({
  message,
  when,
  setWarnWhen,
}) => {
  useBlocker(() => {
    if (when) {
      if (!window.confirm(message)) {
        return true;
      }
      setWarnWhen?.(false);
    }
    return false;
  });
  return null;
};
